export default {
    BRASIL: 1,
}